/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import loadable from '@loadable/component'

import sw from '../../utils/switch'

const Trustpilot = loadable(() => import('./trustpilot'))

export default ({ html, widgetId, variant, options = {} }) =>
  sw({
    trustpilot: () => <Trustpilot options={options} />,
    default: () => <div dangerouslySetInnerHTML={{ __html: html }} sx={{ marginTop: 'md' }} />,
  })(variant || widgetId)
